import { Box, Stack, Typography } from "@mui/material";

type IInfoBanner = {
    backgroundColor: string,
    borderColor: string,
    textColor: string,
    icon?: JSX.Element,
    description: string
}

export const InfoBanner = ({ backgroundColor, borderColor, textColor, icon, description }: IInfoBanner) => {

  return (
    <Stack
      sx={ {
        backgroundColor: backgroundColor,
        border: `0.06rem solid ${ borderColor }`,
        color: textColor,
        borderRadius: "0.25rem",
        padding: "0.75rem 1rem",
        alignItems: "center"
      } }
      flexDirection={ "row" }
      gap={ "0.75rem" }
    >
      { icon && <Box sx={ { display: "flex", alignItems: "center" } }>{ icon }</Box> }
      <Stack
        gap={ "0.5rem" }
      >
        <Typography
          color={ textColor }
          fontWeight={ 500 }
          fontSize={ "1.09rem" }
          lineHeight={ "1.09rem" }
          tabIndex={ -1 }
        >
          { description }
        </Typography>
      </Stack>
    </Stack>
  );
};
